module.exports = __webpack_public_path__ + "img/food-information_odd.f34ddea5.svg";